function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useNavigation } from "@react-navigation/native";
import { useEffect, useRef, useState } from "react";
import { ConfirmationModal } from "./ConfirmationModal";
/**
 * Allows enabling/disabling the modal via the `hasUnsavedChanges` prop. If
 * true, the modal will present itself if the user attempts to navigate away
 * from the current screen.
 *
 * The various texts/button behaviors are customizable.&#x20;
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̄̀̀̃̃̀̀̆̃̀̀̆̃̀̀̃̆̀̀̆̅̀̀̃̃̀̀̆̆̀̀̂̍̀̀̃̀̀̀̃̂̀̀̃̄̀̀̆̄̀̀̂̍̀̀̃̄̀̀̃̃̀̀̆̃̀̀̃̀̀̀̂̍̀̀̆́̀̀̃̆̀̀̃̃̀̀̆̅̀̀̂̍̀̀̆̅̀̀̆̅̀̀̃̉̀̀̃̃̀̀̆̂̀̀̆́̀̀̃̆̀̀̃̀̀̀̃̈̀̀̆́̀̀̃̇̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̄̀̀̃̀̀̀̃̇̀̀̃̀̀̀̃̉̀̀̂̍̀̀̃̂̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̅̀̀̃̈̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̂̀̀̃̂̀̀̃̇̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̃̀̀̃̈̀̀̃̄̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-2}
 */ export function UnsavedChangesModal(_param) {
    var _param_cancelText = _param.cancelText, cancelText = _param_cancelText === void 0 ? 'Discard' : _param_cancelText, _param_confirmText = _param.confirmText, confirmText = _param_confirmText === void 0 ? 'Yes' : _param_confirmText, hasUnsavedChanges = _param.hasUnsavedChanges, props = _object_without_properties(_param, [
        "cancelText",
        "confirmText",
        "hasUnsavedChanges"
    ]);
    var _useState = _sliced_to_array(useState(false), 2), showConfirmationModal = _useState[0], setShowConfirmationModal = _useState[1];
    var _useNavigation = useNavigation(), addListener = _useNavigation.addListener, dispatch = _useNavigation.dispatch;
    var eventRef = useRef(undefined);
    useEffect(function() {
        return addListener('beforeRemove', function(e) {
            eventRef.current = undefined;
            if (hasUnsavedChanges && !showConfirmationModal) {
                e.preventDefault();
                eventRef.current = e.data.action;
                setShowConfirmationModal(true);
            }
        });
    }, [
        hasUnsavedChanges,
        addListener,
        showConfirmationModal
    ]);
    function continueNavigation() {
        setShowConfirmationModal(false);
        if (eventRef.current) {
            dispatch(eventRef.current);
        }
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(ConfirmationModal, _object_spread_props(_object_spread({
            confirmText: confirmText,
            cancelText: cancelText,
            title: "Save changes?",
            description: "Your unsaved changes are about to be lost. Would you like to save before leaving?"
        }, props), {
            onCancel: function() {
                if (props.onCancel) {
                    props.onCancel({
                        continueNavigation: continueNavigation
                    });
                } else {
                    continueNavigation();
                }
            },
            onConfirm: function() {
                return props.onConfirm({
                    continueNavigation: continueNavigation
                });
            },
            visible: showConfirmationModal
        }))
    });
}
